import React, {useCallback, useEffect, useMemo, useRef, useState} from "react"
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";
import {AudioPlayer} from "../../../components/ui/AudioPlayer";

type TextToSpeechPreviewProps = {
    content: string
}

export function TextToSpeechPreview({content}: TextToSpeechPreviewProps) {
    const [lastContent, setLastContent] = useState("")
    const [url, setURL] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const objectURLRef = useRef<string | null>(null);

    useEffect(() => {
        return () => {
            if (objectURLRef.current) URL.revokeObjectURL(objectURLRef.current);
        };
    }, []);

    const canPreview = useMemo(() => (
        content.trim() !== lastContent.trim() && content.trim().length > 0
    ), [content, lastContent]);

    const getPreview = useCallback(() => {
        setLoading(true);
        setError("");

        platformAPI.post<Blob>("api/siren/audio-files/tts/preview", {content}, {responseType: "blob"})
            .then((res) => {
                if (objectURLRef.current) URL.revokeObjectURL(objectURLRef.current);
                const newURL = URL.createObjectURL(res.data);
                objectURLRef.current = newURL;
                setURL(newURL);
                setLastContent(content);
            })
            .catch((err) => {
                if (isAxiosError(err) && err?.response?.data?.error) {
                    setError(err.response.data.error);
                } else {
                    setError("an error occurred");
                }
            })
            .finally(() => setLoading(false));
    }, [content]);

    return (
        <div className="flex flex-col gap-2">
            <button
                type="button"
                disabled={!canPreview || loading}
                onClick={getPreview}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-md border border-light-grey hover:bg-light-light-grey transition-colors disabled:opacity-40 disabled:cursor-not-allowed w-fit"
            >
                {loading ? "Generating…" : "Generate Preview"}
            </button>
            {error && <p className="text-red text-sm">{error}</p>}
            {url && <AudioPlayer src={url}/>}
        </div>
    )
}
